import React, {
  MutableRefObject,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import {
  BasketHistory,
  BasketHistoryDeatils,
  SetNote,
  backupMediaBaseUrl,
  getProduct,
  getProductChildren,
  getProductImage,
  getProducts,
  primaryMediaBaseUrl,
} from "../axios";
import ReactPlayer from "react-player";
import { LibraryItems } from "../models/library";
import ReactQuill, { Quill } from "react-quill";
import "./pdfView.css";
import "react-quill/dist/quill.snow.css";
import { BasketContext } from "../context/BasketProvider";
import { toast } from "react-toastify";
import iconv from "iconv-lite";
import { Buffer } from "buffer";
import PlaybackRate from "./common/PlaybackSpeed";
import Error404 from "../pages/Errors/Error404";
import persianToEnglishNumbers from "../tools/farsiToEnglishNumber";
import CustomVideoPlayer from "./common/custom-video-player/CustomVideoPlayer";
import VideoJS from "./common/custom-video-player/VideoJS";
import videojs from "video.js";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from "@ffmpeg/util";
import log from "video.js/dist/types/utils/log";
import { loadMediaWithFallback } from "../tools/mediaUrlHelper";

const VideoView = () => {
  var { id } = useParams();
  const [src, setSrc] = useState<any>();
  const [vioceUrl, setVioceUrl] = useState<string | null | undefined>("");
  const [loading, setLoading] = useState(true);
  const [children, setChildren] = useState([]);
  const [activeChild, setActiveChild] = useState(1);
  const [mediaImage, setMediaImage] = useState("");
  const [content, setContent] = useState("");
  const [userAllowed, setUserAllowed] = useState<boolean | null>(null);
  const [status, setStatus] = useState("");
  const [mediaType, setMediaType] = useState<string | null>(null);
  const { getBasketHistory, basketDetailsItems, basketHistoryStatus } =
    useContext<any>(BasketContext);

  // let ext = src?.split(".").pop();
  const videoRef = useRef<any>(null);
  const playerRef = useRef<any>(null);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const handlePlaybackSpeedChange = (speed: number) => {
    setPlaybackSpeed(speed);
  };


  const handleSeek = (seconds: number) => {
    const currentTime = playerRef?.current?.getCurrentTime();
    if (currentTime) {
      // console.log("Curent time", currentTime);

      playerRef?.current?.seekTo(currentTime + seconds, "seconds");
    }
  };

  useEffect(() => {
    getBasketHistory();
  }, []);

  //checking if the user have purchased the product before to protect the route
  useEffect(() => {
    const fetchData = async () => {
      try {
        setStatus("pending");
        const newData = basketDetailsItems.flatMap(({ data }: any) =>
          data.filter(
            (item: any) =>
              item.productCategoryID !== 1 && item.productCategoryID !== 4
          )
        );

        const productData = await Promise.all(
          newData.map((item: any) => getProduct(item.productID))
        );

        const finalData = productData.flatMap(({ data }) => data);

        const isUserAllowed = finalData.some((item: any) => item.id == id);

        if (finalData.length > 0) {
          setUserAllowed(isUserAllowed);
          setStatus("idle");
        }
      } catch (error) {
        setStatus("error");
        console.log(error);
      }
    };

    fetchData();
  }, [basketDetailsItems]);

  const handleEditorChange = (value: string): void => {
    setContent(value);
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const ID = basketDetailsItems.filter((item: any) =>
      item?.data.some((innerItem: any) => innerItem.productID === Number(id))
    )[0]?.data[0]?.id;

    try {
      const buffer = iconv.encode(content, "utf8");
      const base64 = buffer.toString("base64");

      await SetNote(ID, base64);
      toast.success("یادداشت با موفقیت ثبت شد");
    } catch (error) {
      toast.error("مشکلی در یادداشت برداری پیش آمده");
    }
  };

  console.log("src", src);

  useEffect(() => {
    id &&
      getProducts()
        .then(({ data }) => {
          const filterProduct: LibraryItems[] = data.filter(
            (p: LibraryItems) => p.id === +id!
          );

          //if the product has children show them as seasons
          //otherwise show the product as video
          const format = filterProduct[0]?.type === "video" ? "mp4" : "mp3";
          setMediaType(format);
          if (
            filterProduct[0].isAsli === true &&
            filterProduct[0].ParentId == 0
          ) {
            getProductChildren(filterProduct[0].id).then(({ data }) => {
              if (data.length > 0) {
                setChildren(data);
                setTimeout(() => {
                  const productUrl =
                    data[0].fileasli !== ""
                      ? data[0].fileasli
                      : data[0].filedemo;
                  loadMediaWithFallback(productUrl, format).then((url) => {
                    setSrc(url);
                  });
                  // const mediaUrl = generateMediaUrl(productUrl, format);
                  // const mediaVoiceUrl = generateMediaUrl(data[0]?.Voice, "mp3");
                  // setVioceUrl(mediaVoiceUrl);
                  // setSrc(mediaUrl);
                }, 2000);
              } else {
                setTimeout(() => {
                  const productUrl =
                    filterProduct[0].fileasli !== ""
                      ? filterProduct[0].fileasli
                      : filterProduct[0].filedemo;
                  loadMediaWithFallback(productUrl, format).then((url) => {
                    setSrc(url);
                  });
                  // const mediaUrl = generateMediaUrl(productUrl, format);
                  // const mediaVoiceUrl = generateMediaUrl(data[0]?.Voice, "mp3");
                  // setVioceUrl(mediaVoiceUrl);
                  // setSrc(mediaUrl);
                }, 2000);
              }
              setLoading(false);
            });
          } else {
            setTimeout(() => {
              const productUrl =
                filterProduct[0].fileasli !== ""
                  ? filterProduct[0].fileasli
                  : filterProduct[0].filedemo;

              loadMediaWithFallback(productUrl, format).then((url) => {
                setSrc(url);
              });
              // const mediaUrl = generateMediaUrl(productUrl, format);
              // const mediaVoiceUrl = generateMediaUrl(data[0]?.Voice, "mp3");
              // setVioceUrl(mediaVoiceUrl);
              // setSrc(mediaUrl);
            }, 2000);
          }
          getProductImage(filterProduct[0].id).then((res) => {
            res.data.length && setMediaImage(res.data[0].img);
            setLoading(false);
          });
        })
        .catch((error) => {
          setLoading(false);
        });
  }, [id]);

  useEffect(() => {
    const item = basketDetailsItems
      .filter((item: any) =>
        item?.data.some((innerItem: any) => innerItem.productID === Number(id))
      )[0]
      ?.data[0]?.note?.split(" ")
      .join("+");
    const buffer = Buffer?.from(item || "", "base64");
    const text = iconv?.decode(buffer || "", "utf8");

    setContent(text || "");
  }, [basketHistoryStatus]);

  const handleChangeSeason = (item: any, index: any) => {
    if (index) setActiveChild(index);
    if (item) {
      const format = item.type === "video" ? "mp4" : "mp3";
      // console.log(item);
      setTimeout(() => {
        const productUrl = item.fileasli !== "" ? item.fileasli : item.filedemo;
        loadMediaWithFallback(productUrl, format).then((url) => {
          setSrc(url);
        });
        // const mediaUrl = generateMediaUrl(productUrl, format);
        // const mediaVoiceUrl = generateMediaUrl(item.Voice, "mp3");
        // setVioceUrl(mediaVoiceUrl);
        // setSrc(mediaUrl);
      }, 2000);
    }

    if (videoRef) {
      videoRef?.current?.scrollIntoView({
        behavior: "smooth", // Smooth scrolling effect
        block: "center", // Align the player at the center of the viewport
      });
    } else return;
  };

  // console.log("src is" , src);

  return (
    <>
      {userAllowed === null || basketHistoryStatus === "pending" ? (
        <div className="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      ) : userAllowed ? (
        <div className="container-fluid videoMain-container d-flex align-items-center justify-content-center px-1 px-md-5">
          <div className="row py-5 w-100 p-0 ">
            {children && children.length > 0 && (
              <div className="season-btns col-12 col-md-2">
                <div className="seasons-title">فصل ها</div>
                <div className="row w-100">
                  {children.map((product: LibraryItems, index) => (
                    <div key={product.id} className="col-12">
                      <p
                        className={
                          activeChild === index + 1 ? "active m-0" : "m-0"
                        }
                        onClick={() => handleChangeSeason(product, index + 1)}
                      >
                        {product?.title}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div
              className="col-12 col-md-10"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                minHeight: 100,
              }}
            >
              {src ? (
                <>
                  {mediaType === "mp4" ? (
                    <>
                      {/* main video */}
                      <div className="w-100" ref={videoRef}>
                        <CustomVideoPlayer src={src} />
                      </div>
                      {/* if product has a atatched vioce file */}
                      {vioceUrl && (
                        <div>
                          <ReactPlayer
                            className="w-100"
                            onContextMenu={(e: React.MouseEvent) =>
                              e.preventDefault()
                            }
                            ref={playerRef}
                            url={vioceUrl}
                            controls
                            playbackRate={playbackSpeed}
                            style={{ maxHeight: 100 }}
                            config={{
                              file: {
                                attributes: {
                                  controlsList: "nodownload",
                                },
                              },
                            }}
                          />
                          <PlaybackRate
                            onPlaybackSpeedChange={handlePlaybackSpeedChange}
                            onSeek={handleSeek}
                          />
                        </div>
                      )}
                      {/* related image if product has it */}
                      {/* {mediaImage && (
                        <img
                          src={mediaImage}
                          alt="Media_Image"
                          className="col-11 col-sm-8 mt-3"
                          style={{ objectFit: "contain" }}
                        />
                      )} */}
                    </>
                  ) : mediaType === "mp3" ? (
                    <>
                      {/* {mediaImage && (
                        <img
                          src={mediaImage}
                          alt="Media_Image"
                          className="col-11 col-sm-8 mt-3"
                          style={{ objectFit: "contain" }}
                        />
                      )} */}

                      <ReactPlayer
                        className="w-100"
                        onContextMenu={(e: React.MouseEvent) =>
                          e.preventDefault()
                        }
                        ref={playerRef}
                        url={src}
                        controls
                        playing
                        playbackRate={playbackSpeed}
                        style={{ maxHeight: 100 }}
                        config={{
                          file: {
                            attributes: {
                              controlsList: "nodownload",
                            },
                          },
                        }}
                      />
                      <PlaybackRate
                        onPlaybackSpeedChange={handlePlaybackSpeedChange}
                        onSeek={handleSeek}
                      />
                    </>
                  ) : (
                    <div className="loader-6 centerLoader">
                      <span></span>
                    </div>
                  )}
                </>
              ) : !loading ? (
                <span>محتوایی برای نمایش وجود ندارد</span>
              ) : (
                <div className="loader-6 centerLoader">
                  <span></span>
                </div>
              )}
            </div>
            {/* <form
              className="col-lg-4 col-md-4 col-md-12 col-xs-12"
              onSubmit={handleFormSubmit}
            >
              <ReactQuill
                modules={{
                  toolbar: [
                    [{ header: [1, 2, false] }],
                    [{ font: [] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ color: [] }, { background: [] }],
                    [{ script: "super" }, { script: "sub" }],
                    [{ align: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image", "video"],
                    ["clean"],
                  ],
                }}
                style={{
                  width: "100%",
                  height: "300px",
                  margin: "24px 0 45px 0",
                }}
                theme="snow"
                value={content}
                onChange={handleEditorChange}
              />
              <button
                type="submit"
                className="btn btn-primary btn-block custom-btn mt-5"
              >
                ثبت
              </button>
            </form> */}
          </div>
        </div>
      ) : (
        <Error404 />
      )}
    </>
  );
};

export default VideoView;
